import React from "react";

import { LoadingIcon } from "@packages/ds";
import { Command, CommandGroup, useCommandState } from "cmdk";

import * as Sticker from "ds/Sticker";

import { useSelectedResource } from "../hooks";
import * as S from "../styles";

import { OrganizationActions } from "./OrganizationActions";
import { ProjectActions } from "./ProjectActions";

type SelectedResourceListProps = {
  selectedResource: {
    type: "projects" | "organizations";
    id: string;
  };
  search: string;
  onListEmpty: () => void;
};

export function SelectedResourceList({
  selectedResource,
  search,
  onListEmpty
}: SelectedResourceListProps) {
  const { data, error, isLoading } = useSelectedResource(selectedResource);
  const { hasEditLink, hasManageAccessLink } = React.useMemo(() => {
    const keys = Object.keys(data?._links ?? {});
    const editLink = keys.includes("#edit");
    const manageAccessLink = keys.includes("#manage-access");
    return { hasEditLink: editLink, hasManageAccessLink: manageAccessLink };
  }, [data?._links]);
  const selectedItem = useCommandState(state => state.value);

  if (!selectedItem && search) {
    onListEmpty();
  }

  return (
    <CommandGroup>
      {error?.message ? (
        <Sticker.Root priority="critical">
          <Sticker.Icon priority="critical" />
          {error.message}
        </Sticker.Root>
      ) : !data && isLoading ? (
        <S.LoaderContainer>
          <Command.Loading>
            <LoadingIcon />
          </Command.Loading>
        </S.LoaderContainer>
      ) : selectedResource.type === "organizations" ? (
        <OrganizationActions organizationId={data.name} />
      ) : (
        <ProjectActions
          projectId={data.id}
          organizationId={data.organization_id}
          defaultBranch={data.default_branch}
          hasEditLink={hasEditLink}
          hasManageAccessLink={hasManageAccessLink}
        />
      )}
    </CommandGroup>
  );
}
